import { Action } from 'redux';

import { isSetLinkEnabledSiteAction } from '../actions/LinkEnabledSiteAction';


export function linkEnabledSiteReducer(
    previousState: boolean = false,
    action: Action = null
): boolean {
    if (isSetLinkEnabledSiteAction(action) && typeof action.isLinkEnabledSite === 'boolean') {
        return action.isLinkEnabledSite;
    } else {
        return previousState;
    }
}
